import { z } from 'zod/v4';

export const StepsSwitchSchema = z.array(
  z.object({
    to: z.coerce.string(),
    from: z.array(z.coerce.string()),
  }),
);

export type StepsSwitch = z.input<typeof StepsSwitchSchema>;
